import type { ReactNode } from 'react'

/**
 * The one eyebrow every "Needs you" card wears.
 *
 * North Star rule 1 (owner, 2026-09-11): *"Every question needing input should
 * use the same 'Needs you' pattern."* Eight cards ask things on /today and,
 * before this, their first line came in four styles: bold widest-tracked
 * brand text, small semibold secondary text, brand medium text, and none at
 * all (the skill checkpoint and the paused-habit card opened straight on the
 * question). The eyebrow is where a card says WHAT KIND of ask it is — see
 * `ORI_KIND_LABEL` — so it is the line that most needs to look the same.
 *
 * Contract: an icon, the kind (a fact, never a command), and optionally the
 * type of item it is about. Nothing else goes on this line.
 */
export function AskEyebrow({
  label, typeWord, icon, className = '',
}: { label: string; typeWord?: string | null; icon?: ReactNode; className?: string }) {
  return (
    <div className={`flex items-center gap-2 text-brand ${className}`}>
      {icon && <span className="shrink-0 [&>svg]:h-4 [&>svg]:w-4" aria-hidden="true">{icon}</span>}
      <span className="text-app-micro font-semibold uppercase tracking-wide">
        {label}
        {typeWord && <span className="font-medium normal-case tracking-normal text-muted"> · {typeWord}</span>}
      </span>
    </div>
  )
}

export default AskEyebrow
